import React from 'react';
import { StyleSheet } from 'react-native';

interface WebViewScreenProps {
  route: {
    params: {
      uri: string;
    };
  };
}

export const WebViewScreen: React.FC<WebViewScreenProps> = ({ route }) => {
  return (
    <iframe
      src={route.params.uri}
      style={{
        width: '100%',
        height: '100vh',
        border: 'none',
      }}
      title="Web Content"
    />
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

export default WebViewScreen; 